import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ngx-form-percentage',
  templateUrl: './form-percentage.component.html',
  styleUrls: ['./form-percentage.component.scss'],
})
export class FormPercentageComponent implements OnInit {
  @Input() title: string;
  @Input() value: string;
  @Output() valueChange: EventEmitter<string>;

  constructor() {
    this.valueChange = new EventEmitter<string>();
  }

  ngOnInit() {
    if (isNaN(Number(this.value))) this.value = '0';
  }


  updateValue(event) {
    this.valueChange.emit(event);
  }
}
